import { ArrayPresenter } from '@/forms/components/presenters/ArrayPresenter';
import { FormFieldType, type ArrayFormField } from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildArrayInitialState } from './initialState';

export const arrayFieldModule: FormFieldModule = {
  type: FormFieldType.Array,
  Presenter: ({ field, disabled }) => (
    <ArrayPresenter fieldsArray={field as ArrayFormField} disabled={disabled} />
  ),
  flattenLeaves: (field, ctx) => ctx.recurse((field as ArrayFormField).fields),
  buildInitialState: buildArrayInitialState,
};
